var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.6667 18.4167V15.5834H9.91671V11.3334L2.83337 17L9.91671 22.6667V18.4167H22.6667Z",
    fill: "#E9F4FA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M28.3333 4.25H15.5833C14.0207 4.25 12.75 5.52075 12.75 7.08333V12.75H15.5833V7.08333H28.3333V26.9167H15.5833V21.25H12.75V26.9167C12.75 28.4792 14.0207 29.75 15.5833 29.75H28.3333C29.8959 29.75 31.1667 28.4792 31.1667 26.9167V7.08333C31.1667 5.52075 29.8959 4.25 28.3333 4.25Z",
    fill: "#E9F4FA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.12483134ff71c206befd5f16f5f8727e.svg";
export { ForwardRef as ReactComponent };